import EditTermsOptionDialog from './EditTermsOptionDialog'

export default EditTermsOptionDialog
